import React from 'react';
import Popover from '@material-ui/core/Popover';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import CircleCheck from './Icons/CircleCheck';
import { InfoCircle } from './Icons';
import { ActiveMonitors, Monitor } from '@raydiant/api-client-js';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    popover: {
      pointerEvents: 'none',
    },
    paper: {
      padding: theme.spacing(1),
    },
  }),
);

interface DevicePeripheralPopoverProps {
  connectedMonitors: ActiveMonitors | null;
}

const DevicePeripheralPopover = ({
  connectedMonitors,
}: DevicePeripheralPopoverProps) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const handlePopoverOpen = (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
  ) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  return (
    <div>
      <div
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="16"
          viewBox="0 0 20 16"
          fill="none"
        >
          <path
            fill="currentColor"
            d="M 4 1.5 L 14 1.5 C 14.273438 1.5 14.5 1.726562 14.5 2 L 14.5 3 L 16 3 L 16 2 C 16 0.898438 15.101562 0 14 0 L 4 0 C 2.898438 0 2 0.898438 2 2 L 2 10 L 0.5 10 C 0.226562 10 0 10.226562 0 10.5 C 0 11.328125 0.671875 12 1.5 12 L 11 12 L 11 10 L 3.5 10 L 3.5 2 C 3.5 1.726562 3.726562 1.5 4 1.5 Z M 12 14.5 C 12 15.328125 12.671875 16 13.5 16 L 18.5 16 C 19.328125 16 20 15.328125 20 14.5 L 20 5.5 C 20 4.671875 19.328125 4 18.5 4 L 13.5 4 C 12.671875 4 12 4.671875 12 5.5 Z M 18.5 14.5 L 13.5 14.5 L 13.5 5.5 L 18.5 5.5 Z M 18.5 14.5 "
          />
        </svg>
      </div>
      <Popover
        id="mouse-over-popover"
        className={classes.popover}
        classes={{
          paper: classes.paper,
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        {connectedMonitors?.monitors?.map((monitor: Monitor, i) => (
          <table className="text-lg" key={monitor.port || `monitor-${i}`}>
            {monitor.port && (
              <tr>
                <td>
                  <CircleCheck className="text-green-600 mr-1" />
                </td>
                <td>{monitor.port} display connected</td>
              </tr>
            )}
            {monitor.message && (
              <tr>
                <td>
                  <InfoCircle className="text-red-600 mr-1" />
                </td>
                <td>{monitor.message}</td>
              </tr>
            )}
          </table>
        ))}
        {connectedMonitors?.error && (
          <table className="text-lg">
            <tr>
              <td>
                <InfoCircle className="text-red-600 mr-1" />
              </td>
              <td>{connectedMonitors.error}</td>
            </tr>
          </table>
        )}
        {!connectedMonitors?.error && connectedMonitors?.monitors == null && (
          <table className="text-lg">
            <tr>
              <td>
                <InfoCircle className="text-red-600 mr-1" />
              </td>
              <td>Unable to detect display</td>
            </tr>
          </table>
        )}
      </Popover>
    </div>
  );
};

export default DevicePeripheralPopover;
